export const Orange = '#f16621'
export const Gray = '#676767'
export const LightGray = '#f6f5f5'
